"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeadCell = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
exports.TableHeadCell = (0, styled_1.default)('th', {
    shouldForwardProp: (prop) => prop !== 'width',
})((props) => ({
    color: constants_1.Color.DARK_GREY,
    fontSize: constants_1.theme.font.size[6.5],
    padding: props.textAlign === 'center' ? '12px 0' : '12px 20px',
    textAlign: props.textAlign ?? 'left',
    userSelect: 'none',
    width: props.width,
}));
